import React, { useEffect, useState, useRef } from "react";
import { KendoGrid } from "../../Kendo/kendo_grid";
import { baseURL, fetch, post, postForm } from "../../Util/axios_helper";
import { KendoTreeTable } from "../../Kendo/kendo_treetable";
import { KendoMultiSelect } from "../../Kendo/kendo_multiselect";
import { useDispatch, useSelector } from "react-redux";
import {
  getFunctionList,
  getEventTypes,
  onFunctionEdit,
} from "../Email/configuration_slice";
import { KendoLoader } from "../../Kendo/kendo_loader";
import {
  Button,
  ErrorMsg,
  GetFormData,
  Loader,
  ValidateForm,
  checkAccess,
  confirmDelete,
  sessionUser,
} from "../../Util/common";
import { getClusterTypes } from "./app_config_slice";

export const FunctionType = ({ selTab }) => {
  const dispatch = useDispatch();

  const { eventType, eventTypeLoaded } = useSelector(
    (state) => state.appConfig
  );
  const { refresh } = useSelector((state) => state.appConfig);
  const [error, setError] = useState({});
  const [newFunctions, setNewFunctions] = useState([]);
  const [functionName, setFunctionName] = useState("");
  const [eventTypeId, setEventTypeId] = useState();
  const [title, setTitle] = useState("");
  const [isAddIcon, setIsAddIcons] = useState(true);
  const [updateData, setUpdateData] = useState({
    EventTypeId: 0,
    FunctionTypeId: 0,
    FunctionTypeName: "",
  });
  const [EventList, setEventList] = useState([]);
  const [FunctionList, setFunctionList] = useState([]);
  const [Loading, setLoading] = useState(false);

  const modalRef = useRef(null);
  const columns = [
    {
      field: "TypeId",
      filterable: false,
      hidden: true,
    },
    {
      field: "TypeName",
      title: "Event Type",
    },
  ];
  const childColumn = [
    {
      field: "FunctionTypeId",
      hidden: true,
    },
    {
      field: "FunctionType",
      title: "Function Type",
    },
  ];

  useEffect(() => {
    if (selTab == 2) {
      dispatch(getClusterTypes());
      const updatedEventType = eventType.filter((event) => event.TypeId !== 3);
      setEventList(updatedEventType);
      if (modalRef.current) {
        $(modalRef.current).on("hidden.bs.modal", () => {
          clearForm();
        });
      }

      return () => {
        if (modalRef.current) {
          $(modalRef.current).off("hidden.bs.modal");
        }
      };
    }
  }, [selTab]);

  const onValidation = (name, val) => {
    setError((prvErr) => {
      return {
        ...prvErr,
        [name]:
          !val || (val && val.trim() == "") || (val && val.trim().length == 0),
      };
    });
  };

  const clearForm = () => {
    $("#hide").click();
    setLoading(false);
    setFunctionName("");
    setError({});
    dispatch(onFunctionEdit(null));
    setIsAddIcons(true);
    setNewFunctions([]);
    setTitle("");
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    try {
      if (newFunctions.length == 0) {
        setError({ newFunctions: true });
      } else {
        setLoading(true);
        const data = [...newFunctions];

        await post("Configuration/SaveFunctions", data, true, true, false);
        $("#add_fun").modal("hide");
        setFunctionName("");
        setNewFunctions([]);
        clearForm();
        refreshChildGrd();
      }
    } catch (error) {
      console.error(error);
    }
  };

  const refreshChildGrd = () => {
    $(`#reload-eventandfunctions`)
      .next()
      .find(".k-master-row")
      .each(function (index) {
        if ($(this).find("td:first").find("a:first").hasClass("k-i-collapse")) {
          $(this).next().find(".btn-refresh:first").click();
        }
      });
  };

  const onEditClick = async (e) => {
    const eventTypeName = e.TypeName;
    setTitle(eventTypeName);
    const eventTypeId = e.TypeId;
    setEventTypeId(eventTypeId);
    $("#add_fun").modal("show");
    const response = await fetch(
      `Configuration/GetFunctionTypeList?TypeId=${e.TypeId}`
    );
    setFunctionList(response);
  };

  const handleDeleteClick = async (e) => {
    const onDelete = async () => {
      let SavedBy = sessionUser();
      await fetch(
        `Configuration/DeleteFunction?FunctionTypeId=${e.FunctionTypeId}&DeletedBy=${SavedBy}`,
        true,
        false,
        true
      );
      refreshChildGrd();
    };
    confirmDelete(onDelete);
  };

  const onAddFunctiontype = (e) => {
    e.preventDefault();
    setError((prevError) => ({
      ...prevError,
      newFunctions: false,
    }));
    const isDuplicate =
      FunctionList.some(
        (item) =>
          item.FunctionType.trim().toLowerCase() ===
          functionName.trim().toLowerCase()
      ) ||
      newFunctions.some(
        (item) =>
          item.FunctionTypeName.trim().toLowerCase() ===
          functionName.trim().toLowerCase()
      );
    setError((prevError) => ({
      ...prevError,
      FTDuplicate: isDuplicate,
    }));

    const err = ValidateForm(e);

    if (err) {
      setError(err);
    } else if (!isDuplicate) {
      const data = GetFormData(e);
      const newFunction = {
        FunctionId: new Date().getTime(),
        FunctionTypeId: 0,
        FunctionTypeName: data.FunctionTypeNames,
        EventTypeId: eventTypeId,
        SavedBy: sessionUser(),
      };
      setNewFunctions([...newFunctions, newFunction]);
      setFunctionName("");
      setIsAddIcons(true);
      setError({});
    }
  };

  const handleFunctionEditClick = async (e) => {
    setTitle(e.parent.TypeName);
    const response = await fetch(
      `Configuration/GetFunctionTypeList?TypeId=${e.parent.TypeId}`
    );
    setFunctionList(response);
    setUpdateData({
      EventTypeId: e.parent.TypeId,
      FunctionTypeId: e.child.FunctionTypeId,
      FunctionTypeName: e.child.FunctionType,
    });
    setIsAddIcons(false);
    $("#update_fun").modal("show");
  };

  const handleFunctionDeleteClick = (e) => {
    let index = newFunctions.findIndex(
      (item) => item.FunctionId == e.FunctionId
    );

    let temp = newFunctions.filter((item, i) => i !== index);
    setNewFunctions(temp);
  };

  const onUpdate = async (e) => {
    let isDuplicate = false;
    const matchingItem = FunctionList.find(
      (item) => item.FunctionTypeId == updateData.FunctionTypeId
    );
    const FunctionTypeValue = matchingItem ? matchingItem.FunctionType : null;
    const dup = FunctionTypeValue != updateData.FunctionTypeName.trim();
    if (dup) {
      isDuplicate = FunctionList.some(
        (item) =>
          item.FunctionType.trim().toLowerCase() ===
          updateData.FunctionTypeName.trim().toLowerCase()
      );
    }

    e.preventDefault();
    const err = ValidateForm(e);
    if (err) {
      setError(err);
    } else if (!isDuplicate) {
      setLoading(true);
      const data = GetFormData(e);
      data.SavedBy = sessionUser();
      let arr = [data];
      await post("Configuration/SaveFunctions", arr, true, false, false, true);
      clearForm();
      $("#update_fun").modal("hide");
      refreshChildGrd();
    }
  };
  return (
    <>
      <div className="col-auto ms-auto">
        {!eventTypeLoaded ? (
          <div className="col-12">
            <KendoLoader />
          </div>
        ) : (
          <KendoTreeTable
            name={"eventandfunctions"}
            parentTableColumns={columns}
            showParentOptions={
              checkAccess("APPCONFIGCREATE") || checkAccess("APPCONFIGEDIT")
            }
            onParentEditClick={onEditClick}
            showParentDelete={false}
            parentTableData={EventList}
            childTableUrl={
              baseURL + "Configuration/GetFunctionTypeList?TypeId={TypeId}"
            }
            childTableColumns={childColumn}
            showChildOptions={
              checkAccess("APPCONFIGEDIT") || checkAccess("APPCONFIGDELETE")
            }
            showChildEdit={checkAccess("APPCONFIGEDIT")}
            showChildDelete={checkAccess("APPCONFIGDELETE")}
            onChildEditClick={handleFunctionEditClick}
            onChildDeleteClick={handleDeleteClick}
            showChildSearch={true}
            refreshWhen={refresh}
            refreshChildGrd={refreshChildGrd}
            parentpaggable={false}
          />
        )}
      </div>
      {/* <!-- Add Fun Modal --> */}
      <div
        className="modal custom-modal fade"
        id="add_fun"
        role="dialog"
        ref={modalRef}
        aria-hidden="true"
        data-bs-backdrop="static"
      >
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">{title} - Add</h5>
              <button
                type="button"
                className="close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={() => {
                  clearForm();
                }}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <form id="subfun-form" onSubmit={onAddFunctiontype}>
                <div className="row">
                  <div className="col-md-10 mb-3">
                    <label className="form-label">
                      Function Type <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      maxLength={100}
                      className="form-control field"
                      name="FunctionTypeNames"
                      value={functionName}
                      placeholder="Function Type"
                      data-required="true"
                      onChange={(e) => {
                        let isDuplicate = false;

                        isDuplicate =
                          FunctionList.some(
                            (item) =>
                              item.FunctionType.trim().toLowerCase() ===
                              e.target.value.trim().toLowerCase()
                          ) ||
                          newFunctions.some(
                            (item) =>
                              item.FunctionTypeName.trim().toLowerCase() ===
                              e.target.value.trim().toLowerCase()
                          );

                        setError((prevError) => ({
                          ...prevError,
                          FTDuplicate: isDuplicate,
                        }));
                        setFunctionName(e.target.value.trim());
                        onValidation("FunctionTypeNames", e.target.value);
                      }}
                    />
                    {error.FunctionTypeNames && (
                      <ErrorMsg text="Function Type is required" />
                    )}
                    {error.FTDuplicate && (
                      <ErrorMsg text="Function Type is already exist" />
                    )}
                    {error.newFunctions && (
                      <ErrorMsg
                        text={"Please add at least one function type"}
                      />
                    )}
                  </div>
                  <div className="col-md-2 mb-3 ">
                    <button
                      type="submit"
                      className="btn btn-primary"
                      style={{ marginTop: "20px" }}
                      title="Add Function"
                    >
                      <i
                        className={
                          isAddIcon
                            ? "las la-plus-circle"
                            : "las la-check-circle"
                        }
                      ></i>
                    </button>
                  </div>
                </div>
              </form>
              <form id="subgrid-form" onSubmit={onSubmit}>
                <div>
                  {/* {newFunctions && newFunctions.length > 0 && ( */}
                  <span className="k-form-error k-invalid-msg">
                    (Note: Only the items added to the grid will be saved.)
                  </span>
                  <KendoGrid
                    name={"fun-config"}
                    disableToolbar={true}
                    paggable={true}
                    data={newFunctions}
                    columns={[
                      {
                        field: "FunctionId",
                        hidden: true,
                      },
                      {
                        field: "EventTypeId",
                        hidden: true,
                      },
                      {
                        field: "FunctionTypeName",
                        title: "Function Type",
                      },
                    ]}
                    showOptions={true}
                    showDelete={true}
                    showEdit={false}
                    onEditClick={(e) => handleFunctionEditClick(e)}
                    onDeleteClick={(e) => handleFunctionDeleteClick(e)}
                  />
                  {/* )} */}
                </div>
                {Loading ? (
                  <KendoLoader className="d-flex justify-content-end align-items-center" />
                ) : (
                  <div className="text-end btn-mt">
                    <Button
                      name={"Cancel"}
                      isCancelButton={true}
                      id="ballroom-ballfun-cancel"
                      dataBsDismiss={"modal"}
                      onClick={() => {
                        clearForm();
                      }}
                    />
                    <Button name={"Save"} />
                  </div>
                )}
                <button
                  type="button"
                  id="hide"
                  style={{ display: "none" }}
                  data-bs-dismiss={"modal"}
                  onClick={() => {
                    clearForm();
                  }}
                ></button>
              </form>
            </div>
          </div>
        </div>
      </div>
      {/* <!-- /Add Fun Modal --> */}

      {/* <!-- Update Fun Modal --> */}
      <div
        className="modal custom-modal fade"
        id="update_fun"
        role="dialog"
        ref={modalRef}
        aria-hidden="true"
        data-bs-backdrop="static"
      >
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">
                {title}
                {" - Edit"}
              </h5>
              <button
                type="button"
                className="close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={() => {
                  setUpdateData({
                    EventTypeId: 0,
                    FunctionTypeId: 0,
                    FunctionTypeName: "",
                  });
                }}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <form id="subUpdatefun-form" onSubmit={onUpdate}>
                <div className="row">
                  <input
                    type="hidden"
                    name="EventTypeId"
                    value={updateData.EventTypeId}
                  />
                  <input
                    type="hidden"
                    name="FunctionTypeId"
                    value={updateData.FunctionTypeId}
                  />
                  <div className="col-md-12 mb-3">
                    <label className="form-label">
                      Function Type <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      maxLength={100}
                      className="form-control field"
                      name="FunctionTypeName"
                      value={updateData.FunctionTypeName}
                      placeholder="Function Type"
                      data-required="true"
                      onChange={(e) => {
                        const matchingItem = FunctionList.find(
                          (item) =>
                            item.FunctionTypeId == updateData.FunctionTypeId
                        );
                        const FunctionTypeValue = matchingItem
                          ? matchingItem.FunctionType
                          : null;
                        const dup = FunctionTypeValue != e.target.value.trim();
                        if (dup) {
                          const isDuplicate = FunctionList.some(
                            (item) =>
                              item.FunctionType.trim().toLowerCase() ===
                              e.target.value.trim().toLowerCase()
                          );
                          setError((prevError) => ({
                            ...prevError,
                            FTDuplicate: isDuplicate,
                          }));
                        }

                        setUpdateData((prv) => ({
                          ...prv,
                          FunctionTypeName: e.target.value.trim(),
                        }));
                        onValidation("FunctionTypeName", e.target.value);
                      }}
                    />
                    {error.FunctionTypeName && (
                      <ErrorMsg text="Function Type is required" />
                    )}
                    {error.FTDuplicate && (
                      <ErrorMsg text="Function Type is already exist" />
                    )}
                  </div>
                  {Loading ? (
                    <KendoLoader className="d-flex justify-content-end align-items-center" />
                  ) : (
                    <div className="text-end btn-mt">
                      <Button
                        name={"Cancel"}
                        isCancelButton={true}
                        id="ballroom-ballfun-cancel"
                        dataBsDismiss={"modal"}
                        onClick={() => {
                          clearForm();
                        }}
                      />
                      <Button name={"Update"} />
                    </div>
                  )}
                  <button
                    type="button"
                    id="hide"
                    style={{ display: "none" }}
                    data-bs-dismiss={"modal"}
                    onClick={() => {
                      clearForm();
                    }}
                  ></button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      {/* <!-- /Update Fun Modal --> */}
    </>
  );
};
